<div
  aria-hidden="true"
  *ngIf="
    !(flightLegData?.flightStatus | jbIncludesSubstring: 'CANCELLED') &&
    !(flightLegData?.flightStatus | jbIncludesSubstring: 'TROUBLE')
  "
  [ngClass]="{
    'fl relative pv1 b': true,
    'animation-reduced-width': !useFullWidth,
    'animation-full-width': useFullWidth
  }"
>
  <!--First Dots-->
  <svg
    *ngIf="
      approxPercentFlightRemaining === 1 &&
      !(flightLegData?.flightStatus | jbIncludesSubstring: 'CLOS') &&
      !(flightLegData?.flightStatus | jbIncludesSubstring: 'BOARDING')
    "
    class="fl relative z-3 dot-height"
    height="10"
    width="10"
  >
    <circle
      cx="5"
      cy="5"
      r="3"
      stroke="#00205b"
      stroke-width="2"
      fill="white"
    />
  </svg>
  <svg
    *ngIf="
      approxPercentFlightRemaining < 1 ||
      (flightLegData?.flightStatus | jbIncludesSubstring: 'CLOS') ||
      (flightLegData?.flightStatus | jbIncludesSubstring: 'BOARDING')
    "
    class="fl relative z-3 dot-height"
    height="10"
    width="10"
  >
    <circle
      cx="5"
      cy="5"
      r="3"
      stroke="#00205b"
      stroke-width="2"
      fill="black"
    />
  </svg>
  <!--Planes-->
  <jb-icon
    *ngIf="
      approxPercentFlightRemaining === 1 &&
      !(flightLegData?.flightStatus | jbIncludesSubstring: 'CLOS') &&
      !(flightLegData?.flightStatus | jbIncludesSubstring: 'BOARDING')
    "
    class="absolute z-4 fill-core-blue outlined-plane-rotation plane-position"
    name="inflightProgressPlaneEmpty"
    width="1.5em"
    height="1.5em"
  ></jb-icon>
  <svg
    *ngIf="
      approxPercentFlightRemaining < 1 ||
      (flightLegData?.flightStatus | jbIncludesSubstring: 'CLOS') ||
      (flightLegData?.flightStatus | jbIncludesSubstring: 'BOARDING')
    "
    [@animatePlane]="approxPercentFlightRemaining"
    class="absolute z-4 plane-position"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs><path id="a" d="M0 0H21.72v10.666H0z" /></defs>
    <g transform="translate(1 7)" fill="none" fill-rule="evenodd">
      <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
      <path
        d="M20.137 3.447l-7.546-.03-2.113-2.96A.7.7 0 0 0 9.86.079L8.628.074a.7.7 0 0 0-.692.813L9.06 3.405l-4.918-.02L3.133.73A1.126 1.126 0 0 0 2.086.004L1.13 0A1.125 1.125 0 0 0 .022 1.34l.832 4.309c.104.528.566.91 1.103.912l7.23-.047-.827 3.24a.775.775 0 0 0 .76.907l1.368.005a.778.778 0 0 0 .687-.413L13.73 6.53l6.395.1c.435.002.834-.173 1.122-.464.288-.286.47-.683.473-1.124a1.593 1.593 0 0 0-1.583-1.596"
        fill="#00205b"
        mask="url(#b)"
      />
    </g>
  </svg>
  <!--Dot for RETURNED or DIVERTED or REFUELING flights-->
  <span
    *ngIf="
      (flightLegData?.flightStatus | jbIncludesSubstring: 'RETURNED') ||
      (flightLegData?.flightStatus | jbIncludesSubstring: 'DIVERSION') ||
      (flightLegData?.flightStatus | jbIncludesSubstring: 'REFUELLING')
    "
    [ngClass]="
      {
        '1': 'return-dot-0-100',
        '0.8': 'return-dot-20',
        '0.6': 'return-dot-40',
        '0.4': 'return-dot-60',
        '0.2': 'return-dot-80',
        '0': 'return-dot-0-100'
      }[approxPercentFlightRemaining]
    "
    class="absolute z-3 core-blue"
    >&#9679;</span
  >
  <!--Lines-->
  <svg
    [@animateBlueLine]="{
      value: approxPercentFlightRemaining,
      params: { blueLinePercentage }
    }"
    [ngClass]="{
      'absolute z-2 blue-line-positioning': true,
      'sky-blue': !useCoreBlue,
      'core-blue': useCoreBlue
    }"
    height="3"
    width="1"
  >
    <line
      x1="0"
      y1="1"
      x2="1000"
      y2="1"
      stroke="currentColor"
      stroke-width="2.5"
    />
  </svg>
  <svg
    [ngClass]="{
      'absolute z-1 grey-line-positioning': true,
      'medium-gray': !useCoreBlue,
      'core-blue': useCoreBlue
    }"
    height="3"
    width="1"
  >
    <line
      stroke-dasharray="5,5"
      x1="0"
      y1="1"
      x2="1000"
      y2="1"
      stroke="currentColor"
      stroke-width="2.5"
    />
  </svg>
  <!--Last Dots-->
  <svg
    *ngIf="approxPercentFlightRemaining > 0"
    class="fr relative z-3 dot-height"
    height="10"
    width="10"
  >
    <circle
      cx="5"
      cy="5"
      r="3"
      stroke="#00205b"
      stroke-width="2"
      fill="white"
    />
  </svg>
  <svg
    *ngIf="approxPercentFlightRemaining === 0"
    class="fr relative z-3 dot-height"
    height="10"
    width="10"
  >
    <circle
      cx="5"
      cy="5"
      r="3"
      stroke="#00205b"
      stroke-width="2"
      fill="black"
    />
  </svg>
</div>
